import React, { useState } from 'react';
import { IconActivityHeartbeat, IconMessage } from '@tabler/icons-react';
import { ActionHistoryEntry, SmsLog } from '../../../entities/lead/model/types';
import { formatDateTime } from '../../../shared/lib/utils';
import { Tabs } from '../../../shared/ui/Tabs';

interface Props {
  actions: ActionHistoryEntry[];
  smsLogs?: SmsLog[];
}

type Tab = 'history' | 'sms';

const CardModalHistoryPane: React.FC<Props> = ({ actions, smsLogs = [] }) => {
  const [tab, setTab] = useState<Tab>('history');

  const tabs = [
    { value: 'history' as Tab, label: <><IconActivityHeartbeat size={13} stroke={1.9} />История</> },
    {
      value: 'sms' as Tab,
      label: (
        <>
          <IconMessage size={13} stroke={1.9} />
          СМС
          {smsLogs.length > 0 && <span className="hist-tab-badge">{smsLogs.length}</span>}
        </>
      ),
    },
  ];

  return (
    <div className="cm-l-col cm-l-col-history">
      <div className="cm-l-panel">
        <Tabs tabs={tabs} active={tab} onChange={setTab} className="hist-tabs" />

        <div className="cm-l-panel-scroll">
          {tab === 'history' && (
            <div className="hist-list">
              {actions.length === 0 && (
                <div style={{ color: 'var(--text3)', fontSize: 13 }}>Изменений пока нет</div>
              )}
              {actions.map(entry => (
                <div className="hist-item hist-item-action" key={entry.id}>
                  <div className="hist-date">
                    {formatDateTime(entry.created)}
                    {entry.expand?.userId?.name ? ` · ${entry.expand.userId.name}` : ''}
                  </div>
                  <div className="hist-text hist-text-action">
                    <span className="hist-action-icon" aria-hidden="true">
                      <IconActivityHeartbeat size={15} stroke={1.9} />
                    </span>
                    <span>{entry.action}</span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {tab === 'sms' && (
            <div className="hist-list">
              {smsLogs.length === 0 && (
                <div style={{ color: 'var(--text3)', fontSize: 13 }}>СМС пока нет</div>
              )}
              {smsLogs.map(sms => (
                <div
                  className={`hist-item${sms.status === 'error' ? ' hist-item-sms-error' : ' hist-item-sms-ok'}`}
                  key={sms.id}
                >
                  <div className="hist-date" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    {formatDateTime(sms.created)}
                    <span
                      className={`hist-sms-status${sms.status === 'error' ? ' hist-sms-status-error' : ' hist-sms-status-ok'}`}
                    >
                      {sms.status === 'error' ? 'ошибка' : 'ок'}
                    </span>
                  </div>
                  {sms.phone && <div className="hist-text" style={{ color: 'var(--text3)' }}>{sms.phone}</div>}
                  {sms.text && <div className="hist-text">{sms.text}</div>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { CardModalHistoryPane };
